import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { closeAtlasPreview } from '../../redux/atlasPreview/actions'
import { atlasPreviewState } from '../../redux/atlasPreview/selectors'
import { requestStartMessagesDm } from '../../redux/atlasai/actions'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import AtlasPreviewCard, { IProps } from './AtlasPreviewCard'

const selector = createStructuredSelector({
  previewState: atlasPreviewState,
})
const actions = {
  closeAtlasPreview,
  requestStartMessagesDm,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(
  connector,
  AtlasPreviewCard,
)
